<template>
  <PrintTemplate
    :viewExtraFooter="false"
    :viewHeader="false"
    :viewFooter="false"
    :finalize-url="finalizeUrl"
    :finalize-payload="finalizePayload"
    :show-finalize-button="true"
    finalize-button-label="Send PDF"
    orientation="landscape"
  >
    <div v-if="errorMessage" class="error-state">
      {{ errorMessage }}
    </div>
    <table v-else class="table table-bordered">
      <tr>
        <td colspan="4" class="text-center">
          <span class="float-left">1.</span>
          <b>Approving Competent Authority/Country</b> <br />
          <span style="margin-top: 5px; display: block; font-size: 16px">
            <b>EASA</b>
          </span>
        </td>
        <td colspan="5" class="text-center">
          <span class="float-left">2.</span>
          <b>AUTHORISED RELEASE CERTIFICATE <br>EASA FORM 1</b> <br />
        </td>

        <td colspan="3" class="text-center">
          <span class="float-left">3.</span>Form Tracking Number <br />
          <span style="margin-top: 5px; display: block; font-size: 16px">
            {{ formModel.form_one ? formModel.form_one.form_one_id : "" }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="9">
          <div class="address-row">
            <div class="mr-2 ">
              <span class="float-left">4. Organisation Name and Address:</span>
              <br />
              <div class="ml-2">
                <img height="50px" src="/images/form1-header.png" alt="" />
              </div>
            </div>
            <p
              class="mr-2 mt-0 address-text"
              style="font-weight: bold; cursor: pointer; margin-bottom: 0px"
              @click="openAddressWindow"
              v-html="renderAddress"
            ></p>
          </div>
        </td>
        <td colspan="3" class="text-center">
          <span class="float-left">5.</span> Work Order/Contract/Invoice:
          <br />
          <span style="margin-top: 10px; display: block; font-size: 16px">
            {{ formModel.jo_no }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="1">6. Item</td>
        <td colspan="3">7. Description</td>
        <td colspan="2">8. Part No.</td>
        <td colspan="1">9. Qty</td>
        <td colspan="2">10. Serial No.</td>
        <td colspan="3">11. Status/Work</td>
      </tr>
      <tr>
        <td
          colspan="1"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          1
        </td>
        <td
          colspan="3"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.description }}
        </td>
        <td
          colspan="2"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.jo_part }}
        </td>
        <td
          colspan="1"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          1
        </td>
        <td
          colspan="2"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.uld_id_code }}
        </td>
        <td
          colspan="3"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          Repaired
        </td>
      </tr>
      <tr>
        <td colspan="12">
          <span style="position: absolute; float: left">
            12. Remarks:
            <a href="#" @click.stop="openWindow"
              ><span class="el-icon-edit h-print"></span>
            </a>
          </span>
          <div class="text-center">
            {{ remarks }}
          </div>
          <div class="text-center" style="">
            {{ masterlist.cmm.rev_desc }}, {{ masterlist.cmm.other_manuals }}
          </div>
        </td>
      </tr>
      <tr>
        <td
          id="td-1"
          class="diagonal-cell"
          style="width: 50%; background: #CCC; "
          colspan="6"
          rowspan="3"
        >
          <div class="diagonal-overlay">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none">
              <line x1="0" y1="0" x2="100" y2="100"></line>
              <line x1="0" y1="100" x2="100" y2="0"></line>
            </svg>
          </div>
          <div class="form13-block">
            <div class="form13a">
              <span
                >13a. Certifies that the items identified above were
                manufactured in conformity to:</span
              >
              <div class="form-item mt-1">
                <span class="xbox"></span>
                <label for="cbx_13a"
                  >approved design data and are in condition for safe
                  operation</label
                >
              </div>
              <div class="form-item">
                <span class="xbox"></span>
                <label for="cbx_13b"
                  >non-approved design data specified in block 12</label
                >
              </div>
            </div>
            <div class="form13-grid">
              <div class="form13-cell">
                <span>13b. Authorised Signature</span>
              </div>
              <div class="form13-cell">
                <span>13c. Approval/Authorisation Number</span>
              </div>
            </div>
            <div class="form13-grid">
              <div class="form13-cell">
                <span>13d. Name</span>
              </div>
              <div class="form13-cell">
                <span>13e. Date (dd mmm yyyy)</span>
              </div>
            </div>
          </div>
        </td>
        <td style="width: 50%" colspan="6">
          <div class="form-item mb-1">
            <span>14a.</span>
            <span class="xbox">
              <span class="el-icon-close"></span>
            </span>
            <label for="cbx_14a"><u>Part 145.A.50</u> Release to Service </label>
            <span class="xbox"></span>
            <label for="cbx_14a">Other regulation specified in block 12</label>
          </div>
          <p style="font-size: 14px; margin-bottom: 0; ">
            Certifies that unless otherwise specified in block 12, the work identified in 
            block 11 and described in block 12, was accomplished in accordance with <u>Part 145</u>
            and in respect to that work the items are considered ready for release to service
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="3" style="width: 25%">
          <span class="signature-label">14b. Authorised Signature</span>
          <div class="signature-block">
            <div class="signature-image-wrapper">
              <img
                class="signature-image"
                v-if="formModel.supervisor.sign"
                :src="getPath(formModel.supervisor.sign)"
              />
            </div>
          </div>
        </td>
        <td colspan="3" style="width: 25%">
          <span>14c. Certificate/Approved Ref. No.</span> <br />
          <div class="text-center mt-1">
            <b>EASA.145.0928</b>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span>14d. Name</span>
          <div class="text-center mt-1">
            {{ formModel.supervisor.fullname }}
          </div>
        </td>
        <td colspan="3">
          <span>14e. Date (dd mmm yyyy)</span>
          <div class="text-center mt-1">
            {{ formModel.date_job_completed }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="12">
          <b>USER/INSTALLER RESPONSIBILITIES </b>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 4px">
            This certificate does not automatically constitute authority to install the item(s).
          </p>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 4px">
            Where the user/installer performs work in accordance with the regulations of an airworthiness authority different 
            than the airworthiness authority specified in block 1, 
            it is essential that the user/installer ensures that his/her airworthiness 
            authority accepts items from the airworthiness authority specified in block 1.
          </p>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 0">
            Statements in blocks 13a and 14a do not constitute installation certification. 
            In all cases the aircraft maintenance records must contain an installation certification 
            issued in accordance with the national regulations by the user/installer before the aircraft 
            may be flown.
          </p>
        </td>
      </tr>
    </table>
    <div class="form1-footer">
      <span class="form1-left">EASA Form 1 - MF/CAO/145 Issue 3</span>
      <span class="form1-center">PRINTED FROM ELECTRONIC FILE</span>
      <span class="form1-spacer"></span>
    </div>
    <el-dialog
      :visible.sync="windowState"
      min-width="250px"
      title="Input remarks"
    >
    <el-input
      type="textarea"
      :rows="3"
      placeholder="Remarks here"
      label-position="top"
      v-model="remarks">
    </el-input>
      <!-- <el-form :model="remark" label-position="top">
        <el-form-item>
          <el-select v-model="remark.id">
            <el-option
              v-for="item in remarkList"
              :key="item.id"
              :value="item.id"
              :label="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->
    </el-dialog>
    <el-dialog
      :visible.sync="addressWindowState"
      min-width="250px"
      title="Edit Address"
    >
      <el-form>
        <el-form-item>
          <el-input type="textarea" :rows="5" v-model="address"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </PrintTemplate>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplateLandscape.vue";
import ULD from "@/models/ULD";
import Masterlist from "@/models/Masterlist";
import moment from "moment";
import { getJobOrderNumber } from "@/utils/jobOrder";
export default {
  name: "Form1A",
  components: { PrintTemplate },
  data: () => ({
    formModel: new ULD({ supervisor: {}, mechanic: {} }),
    isLoading: false,
    customers: [],
    masterlist: { cmm: {} },
    windowState: false,
    remarks: 'This C6 equipment was repaired in accordance with the following OEM’s Manual:',
    addressWindowState: false,
    address:
      (process.env.VUE_APP_ULD_ADDRESS &&
        process.env.VUE_APP_ULD_ADDRESS.replace(/\\n/g, "\n")) ||
      "Dubai Investment Park-2\nPlot No. 597-373, Facility No. 4\nDubai, United Arab Emirates\nTel. No.: +971 4 3856084\nE-mail: uld_repair.dxb@totalx.ae",
    errorMessage: "",
    remarkList: [
      {
        id: 0,
        text:
          "This C6 equipment was repaired in accordance with the following OEM’s Manual:"
      },
      {
        id: 1,
        text:
          "This Pallet Net was repaired in accordance with below OEM’s Component Maintenance Manual:"
      },
      {
        id: 2,
        text:
          "This Galley Cart was repaired in accordance with below OEM’s Component Maintenance Manual:"
      }
    ]
  }),
  computed: {
    trackingNo() {
      return "TXRC.20.0001";
    },
    // remarks() {
    //   return this.remarkList.find(o => o.id == this.remark.id);
    // },
    currdate() {
      let str = moment()
        .format("DD MMM YYYY")
        .toLowerCase();
      return str;
    },
    renderAddress() {
      return this.address.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    finalizeUrl() {
      if (this.formModel && this.formModel.id) {
        return `/api/v1/repair/uld/${this.formModel.id}/finalize/`;
      }
      return "";
    },
    finalizePayload() {
      const user = this.$store.getters["auth/user"];
      return {
        email: user ? user.email : ""
      };
    }
  },
  methods: {
    getPath(data) {
      return "data:image/jpg;base64," + data;
    },
    openWindow() {
      this.windowState = true;
    },
    openAddressWindow() {
      this.addressWindowState = true;
    },
    getApiErrorMessage(error) {
      if (error && error.response && error.response.data) {
        const responseData = error.response.data;
        if (typeof responseData === "string") {
          return responseData;
        }
        if (Array.isArray(responseData)) {
          return responseData.join(", ");
        }
        if (responseData.message) {
          return responseData.message;
        }
        if (responseData.detail) {
          return responseData.detail;
        }
        if (responseData.error) {
          return responseData.error;
        }
        if (responseData.errors) {
          if (Array.isArray(responseData.errors)) {
            return responseData.errors.join(", ");
          }
          if (typeof responseData.errors === "object") {
            const nestedErrors = [];
            Object.keys(responseData.errors).forEach(key => {
              const value = responseData.errors[key];
              if (Array.isArray(value)) {
                nestedErrors.push(...value);
              } else if (value) {
                nestedErrors.push(value);
              }
            });
            if (nestedErrors.length) {
              return nestedErrors.join(", ");
            }
          }
        }
      }
      if (error && error.message) {
        return error.message;
      }
      return "Unable to load the requested ULD record.";
    },
    async fetchFormDetails(id) {
      this.isLoading = true;
      this.errorMessage = "";
      try {
        const data = await ULD.list({ id });
        if (!data || !data.data || !data.data.length) {
          this.errorMessage = "Unable to find the requested ULD record.";
          return;
        }
        const item = data.data[0];

        this.formModel = new ULD({
          id: item.id,
          jo_no: getJobOrderNumber(item.id),
          location_id: item.location.id,
          masterlist_id: item.masterlist.id,
          status_id: item.status.id,
          type: item.type,
          description: item.description,
          date_received: item.date_received,
          job_completed: item.job_completed,
          date_job_completed: moment(item.job_completed)
            .format("D MMM YYYY")
            .toLowerCase(),
          mechanic: item.mechanic,
          supervisor: item.supervisor,
          labor: item.labor,
          locked: item.locked ? true : false,
          materials: item.materials,
          damages: item.damages,
          customer: item.customer,
          customer_desc: this.customers.find(o => {
            return o.value == item.customer;
          }),
          form_one: item.form_one ? item.form_one : {}
        });

        const masterlistResp = await Masterlist.list({
          id: item.masterlist.id
        });
        if (masterlistResp && masterlistResp.data && masterlistResp.data.length) {
          this.masterlist = masterlistResp.data[0];
        }

        const date = moment().format("YYYY-MM-DD");
        document.title = "TX Repair Software - ULD Form 1A " + date;
      } catch (error) {
        const message = this.getApiErrorMessage(error);
        this.errorMessage = message;
        if (message && this.$message) {
          this.$message.error(message);
        }
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.customers = [];
    ULD.customers_data()
      .then(list => {
        if (list) {
          this.customers = list;
        }
      })
      .catch(() => {});

    const id = this.$route.params.id;
    if (id) {
      this.fetchFormDetails(id);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-size: 14px;
}
table {
  table-layout: fixed;
}
.table-bordered {
  th,
  td {
    border: 1px solid #333;
    padding-top: 8px;
    padding-bottom: 8px;
    vertical-align: top;
  }
}
.float-left {
  float: left;
}
.form-item {
  display: flex;
  align-items: center;
  input.form-control[type="checkbox"] {
    width: 15px;
    margin-right: 8px;
  }
}
.xbox {
  position: relative;
  display: inline;
  margin-left: 8px;
  margin-right: 8px;
  border: 1px solid #888;
  border-radius: 4px;
  color: #000;
  height: 13px;
  width: 14px;
  font-weight: bold;
  background-color: #fff;
  span {
    position: absolute;
    left: -2px;
    top: -2px;
    font-weight: bold;
    font-size: 16px;
  }
}
.diagonal-cell {
  position: relative;
  overflow: hidden;
}
.diagonal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
}
.diagonal-overlay svg {
  width: 100%;
  height: 100%;
}
.diagonal-overlay line {
  stroke: #000;
  stroke-width: 0.8;
  opacity: 1;
}
.form13-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 1;
  background: #ccc;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
}
.form13a {
  position: relative;
  z-index: 1;
  margin-bottom: 8px;
}
.form13-grid {
  display: flex;
  position: relative;
  z-index: 1;
}
.form13-cell {
  flex: 1;
  padding: 8px;
  border-top: 1px solid #333;
}
.form13-cell + .form13-cell {
  border-left: 1px solid #333;
}
.address-text {
  text-align: left;
  flex: 1;
  margin-left: 16px;
}
.address-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form1-footer {
  position: relative;
  font-size: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
  text-align: center;
}
.form1-left {
  position: absolute;
  left: 0;
}
.form1-center {
  display: inline-block;
}
.form1-spacer {
  display: none;
}
.error-state {
  padding: 32px;
  margin-bottom: 16px;
  border: 1px solid #f56c6c;
  border-radius: 4px;
  background: #fde2e2;
  text-align: center;
  font-weight: 600;
  color: #c45656;
}
.form1-left {
  text-align: left;
}
.signature-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.signature-image-wrapper {
  height: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.signature-label {
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
}
.signature-image {
  height: 50px;
  mix-blend-mode: multiply;
}

</style>
